import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useActions } from 'utils/hooks';
// import * as cargoesActions from 'store/cargoes/actions';
import TableActions from 'components/layouts/table';

import Table, { useTable } from 'common/components/table';

import Form from './form';
import { Row, Col } from 'reactstrap';
import _get from 'lodash/get';

import useDrawer from 'common/components/drawer/useDrawer';

import edit from 'assets/svg/actions/edit-empty.svg';
import index_value from 'assets/svg/actions/value.svg';
import company from 'assets/svg/actions/company.svg';
import VesselsTypesSelector from 'common/components/selectors/VesselsTypesSelector';
import CollectionFilterSelector from 'common/components/table/filters/CollectionFilterSelector';
import IndexTypeSelector from 'components/selectors/IndexTypeSelector';
import BulkActions from 'views/indexes/components/BulkActions';
import TableHeader from 'common/components/table/header';

import { selectTableListSelectedRows } from 'common/components/table/store/selectors';

import * as tableListActions from 'common/components/table/store/actions';

const Indexes = () => {
  const [active, setActive] = useState(null);
  const [editMode, setEditMode] = useState(null);
  const [bulk, setBulk] = useState(false);
  const [isRowSelectable, setIsRowSelectable] = useState(false);
  const [clearSelectedTableRows] = useActions([tableListActions.clearSelectedTableRows]);

  const selectedRows = useSelector(state => selectTableListSelectedRows(state, 'market-indexes'));

  const drawer = useDrawer(false);
  const table = useTable({
    label: 'market-indexes',

    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 2
      },
      {
        header: 'Index type',
        key: 'type_id',
        type: 'collection',
        component: IndexTypeSelector,
        componentRest: { isMulti: true },
        sort: true,
        width: 2
      },
      {
        header: 'Frequency',
        key: 'frequency',
        className: 'text-capitalize',
        type: 'string'
      },
      {
        header: 'Vessel type',
        key: 'vessel_type_id',
        type: 'collection',
        component: VesselsTypesSelector,
        componentRest: { isMulti: true },
        sort: true
      },
      {
        header: 'Vessel subtype',
        key: 'vessel_subtype_id',
        type: 'collection',
        component: CollectionFilterSelector,
        componentRest: {
          memoizedRequestParams: { path: '/lists', params: { list: 'vessel-subtypes' } }
        },
        sort: true
      },
      {
        header: 'Source',
        key: 'source',
        type: 'string'
      },
      {
        header: 'Issuer',
        key: 'issuer',
        type: 'string',
        sort: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center'
      }
    ]
  });

  const tableProps = isRowSelectable
    ? {
        isRowSelectable: () => true,
        selectedRowsLabel: 'indexes'
      }
    : {};

  return (
    <>
      <Row className="market-indexes-table" onClick={() => (drawer.isOpen ? drawer.close() : null)}>
        <Col xs={12} className="mb-5">
          <TableActions
            title="Indexes"
            documentTitle="Market-indexes"
            actions={[
              { type: 'search' },
              {
                type: 'add',
                text: 'Add Index',
                color: 'primary',
                onClick: () => {
                  setActive(null);
                  setEditMode('createIndex');
                  drawer.open();
                }
              }
            ]}
          />
        </Col>
        <Col xs={12}>
          <TableHeader {...table} />
          <BulkActions
            onBulkSelect={() => setIsRowSelectable(true)}
            onBulkClose={() => {
              setIsRowSelectable(false);
              clearSelectedTableRows('market-indexes');
            }}
            onSelectIndexValue={() => {
              setBulk(true);
              setActive(null);
              setEditMode('values');
              drawer.open();
            }}
            isRowSelectable={isRowSelectable}
            label="market-indexes"
          />
          <Table
            key={isRowSelectable ? 'selectable_table' : ''}
            loader
            hideTopPagination
            hideTableFilters
            hideTableSearch
            rows={{
              type_id: data => (
                <div className="d-flex align-items-center">{_get(data, 'type.name', '-')}</div>
              ),
              vessel_type_id: data => (
                <div className="d-flex align-items-center">
                  <span className="ps-1">
                    {_get(data, 'vessel_type.name', '') || _get(data, 'vessel_type', '')}
                  </span>
                </div>
              ),
              vessel_subtype_id: data => (
                <div className="d-flex align-items-center">
                  {_get(data, 'vessel_subtype.name', '-')}
                </div>
              ),
              actions: {
                options: [
                  {
                    label: 'Edit Index',
                    icon: edit,
                    onClick: (_, row) => {
                      setEditMode('editIndex');
                      setActive(row);
                      setBulk(false);
                      drawer.open();
                    }
                  },
                  {
                    label: 'Edit Index Values',
                    icon: index_value,
                    onClick: (_, row) => {
                      setEditMode('values');
                      setBulk(false);
                      setActive(row);
                      drawer.open();
                    }
                  },
                  {
                    label: 'Edit Visibility',
                    icon: company,
                    onClick: (_, row) => {
                      setEditMode('visibility');
                      setBulk(false);
                      setActive(row);
                      drawer.open();
                    }
                  }
                ]
              }
            }}
            {...table}
            {...tableProps}
          />
        </Col>
      </Row>

      <Form
        drawer={drawer}
        refetchData={table.refetchData}
        editMode={editMode}
        bulk={bulk}
        selected={selectedRows}
        active={active}
      />
    </>
  );
};

export default Indexes;
